import { Step } from '../../services/types';

export const getNextStep = (steps: any[], currentStep: Step) => {
  const currentIndex = steps.findIndex(step => step.id === currentStep);

  if (currentIndex === -1 || currentIndex === steps.length - 1) {
    return null; // Manejo para el caso donde no se encuentra currentStep o es el último paso
  }

  const nextStep = steps[currentIndex + 1];
  return nextStep;
};
